import Axios from "./axios";
import qs from 'qs';
import Mappings from "./api.mappings";
export class ListApi {
    constructor() {
        /**
         * 导入文件上传地址
         */
        this.fileUploadUrl = `/api/runtime/query/upload_file`;
    }
    /**
     * 点击新增按钮判断用户是否有权限创建业务表单
     * @param params
     */
    getJurisdiction(params) {
        return Axios.post(Mappings.form.add, params);
    }
    getDataItems(params) {
        return Axios.get(`/api/app/bizproperty/list`, { params });
    }
    /**
     * 关闭弹框时触发清除临时文件
     * @param params
     */
    deleteTemporaryFile(params) {
        return Axios.post(Mappings.application.deleteTemporaryFile, params);
    }
    /**
     * 下载示例文件
     * @param params
     */
    exportTemplate(params) {
        let pathname = window.location.pathname;
        let axiosUrl = Mappings.application.queryExportTemplate;
        if (pathname === "/application/total_Rewards_Bankend/application-list/personal_DataTemplatenew") {
            axiosUrl = "/api/totalrewardsbankends/downloadExcelTemplate";
        }
        return Axios.post(axiosUrl, params, {
            responseType: "arraybuffer",
        });
    }
    /**
     * 导入失败错误信息下载
     * @param params
     */
    exportErrorResult(fileName) {
        const params = {
            fileName,
        };
        return Axios.post(Mappings.application.queryDownloadResult, params, {
            responseType: "arraybuffer",
        });
    }
    /**
     * 导入失败错误信息下载-新增
     * @param params
     */
    downErrorResult(fileName) {
        const params = {
            fileName,
        };
        return Axios.post(Mappings.application.downloadResult, params, {
            responseType: "arraybuffer",
        });
    }
    /**
     * 导入数据
     * @param params
     */
    importData(params) {
        return Axios.get(Mappings.application.queryImportData, { params });
    }
    /**
     * 按姓名选人错误，二次确认导入数据
     * @param params
     */
    secondImportData(params) {
        return Axios.post(Mappings.application.secondImportData, params);
    }
    sheetSecondImportData(params) {
        return Axios.post(Mappings.application.sheetSecondImportData, params);
    }
    /**
     * 查询导入进度
     */
    getImportingProgress(params) {
        return Axios.get(Mappings.application.queryImportProgress, {
            params,
        });
    }
    // 注释和注释风格
    //应用列表
    list(params) {
        return Axios.get(Mappings.application.appListApps, { params });
    }
    //应用组列表
    listByGroup(params) {
        return Axios.get(Mappings.application.appListAppsByGroup, { params });
    }
    //最近使用应用列表
    listRecently(params) {
        return Axios.get(Mappings.application.appListRecentlyUsedApp, { params });
    }
    //收藏应用列表
    listFavorite(params) {
        return Axios.get(Mappings.application.appListFavorite, { params });
    }
    //新增收藏应用
    createFavorite(params) {
        return Axios.get(Mappings.application.appListCreateFavorite, { params });
    }
    //删除收藏应用
    deleteFavorite(params) {
        return Axios.delete(Mappings.application.appListDeleteFavorite, { params });
    }
    //查询应用接口
    listForTrust(params) {
        return Axios.get(Mappings.application.appListAppsForTrust, {
            params,
        });
    }
    // 获取目录
    getFolder(params) {
        return Axios.get(Mappings.application.appListFunctionsByCode, {
            params,
        });
    }
    // 获取子目录,即模型
    getModel(params) {
        return Axios.get(Mappings.application.appListFunctionsById, {
            params,
        });
    }
    // 获取模型配置信息
    getListConfigData(params) {
        return Axios.get(Mappings.application.appQueryGet, { params });
    }
    getListConfigList(schemaCode, isPublish, appCode) {
        return Axios.get(Mappings.application.appQueryList, {
            params: {
                schemaCode,
                isPublish,
                currentAppCode: appCode,
            },
        });
    }
    // 获取已点亮视图列表
    getQueryHeaders(params) {
        return Axios.get(Mappings.application.queryHeaders, { params });
    }
    // 获取查询列表数据
    getQueryList(params) {
        return Axios.post(Mappings.application.queryList, params);
    }
    // 跳过列表查询
    listSkipQueryList(params) {
        return Axios.post(Mappings.application.listSkipQueryList, params);
    }
    //多了id赋值
    listSkipQueryListV2(params) {
        return Axios.post(Mappings.application.listSkipQueryListV2, params);
    }
    //判断模型数据存在
    getExistItem(params) {
        return Axios.post(Mappings.application.getExistItem, params);
    }
    // 获取查询列表数据
    queryReverse(params) {
        return Axios.post(Mappings.application.queryListReverseSheet, params);
    }
    // 获取查询列表表单Url
    getFormUrl(params) {
        return Axios.get(Mappings.application.getFormUrl, { params });
    }
    // 删除列表
    deleteListData(params) {
        return Axios.delete(Mappings.application.deleteListData, {
            data: params,
        });
    }
    // 导出数据
    exportData(params) {
        return Axios.post(Mappings.application.queryExportData, params, {
            responseType: "arraybuffer",
        });
    }
    // 导出数据(后台异步导出文件)
    exportAsyncData(params) {
        return Axios.post(Mappings.application.queryAsyncExportData, params);
    }
    /**
     * 查询导出进度
     */
    getExportingProgress(params) {
        return Axios.get(Mappings.application.queryExportProgress, {
            params,
        });
    }
    getExportFile(params) {
        //  salary_letter_config 列表的下载需要走新的加密下载
        let pathname = window.location.pathname;
        let axiosUrl = Mappings.application.getExportData;
        if (pathname === "/application/salary_letter/application-list/salary_letter_config" || pathname === "/application/salary_letter/application-list/salary_letter_report" || pathname === "/application/salary_letter/application-list/hrbp_view") {
            axiosUrl = "/api/runtime/query/export_data/async/export_file_password";
        }
        return Axios.post(axiosUrl, params, {
            responseType: "arraybuffer",
        });
    }
    getExportTaskList(params) {
        return Axios.post(Mappings.application.getExportTaskList, params);
    }
    //删除导出任务
    deleteExportTaskList(params) {
        return Axios.get(Mappings.application.deleteExportTaskList, { params });
    }
    /* 获取应用目录、模型 */
    getAppItem(params) {
        return Axios.get(Mappings.application.appPackageTree, {
            params,
        });
    }
    /* 根据模型编码获取应用编码 */
    getAppCodeByModelCode(params) {
        return Axios.get(Mappings.application.getAppCodeByModelCode, {
            params
        });
    }
    /**
     * 获取所有应用列表
     */
    getAllApps(params) {
        return Axios.get("/api/app/apppackage/list_all", {
            params,
        });
    }
    appSearch(params) {
        return Axios.get(Mappings.application.appPackageSearch, {
            params,
        });
    }
    /**
     * 根据名称搜索流程模板
     */
    searchWorkflowByName(params) {
        return Axios.get(Mappings.application.searchWorkflowByName, {
            params,
        });
    }
    /**
     * 获取流程
     *  */
    getWorkflowList(params) {
        return Axios.get(Mappings.workflow.workflowList, { params });
    }
    /**
     * 获取流程-委托
     *  */
    getWorkflowListTrust(params) {
        return Axios.get(Mappings.workflow.workflowListTrust, { params });
    }
    /**
     * 获取单应用信息
     * @param appCode
     */
    getSingleAppInfo(appCode) {
        const params = {
            appCode,
        };
        return Axios.get(Mappings.application.appPackageGetSingleInfo, {
            params,
        });
    }
    /**
     * 单应用查询表单
     * @param appCode
     */
    searchBizModels(params) {
        return Axios.get(Mappings.application.appSearchBizModels, {
            params,
        });
    }
    /**
     * 最近使用的业务模型
     */
    listRecentBizModel() {
        return Axios.get(Mappings.application.appListRecentBizModels);
    }
    /**
     * 业务模型数据项列表
     */
    getDataItemList(params) {
        return Axios.get(Mappings.application.importQueryField, { params });
    }
    /**
     * 检查删除数据是：流程数据还是业务数据，是否父流程数据
     */
    checkDeleteItems(params) {
        return Axios.post(Mappings.application.checkDeleteItem, params);
    }
    /**
     * 批量生成二维码
     */
    genShortCodes(params) {
        return Axios.post(Mappings.application.genShortCodes, params);
    }
    getReport(params) {
        return Axios.get(Mappings.application.getReport, {
            params,
        });
    }
    //修改拥有者
    modifyOwner(params) {
        return Axios.post(Mappings.application.bizobjects, params);
    }
    //批量修改拥有者时获取无权限修改的数量
    getNoPresentationNumber(params) {
        return Axios.post(Mappings.application.objectIds, params);
    }
    getAppPackage(code) {
        const params = {
            code,
        };
        return Axios.get(Mappings.application.getAppPackage, {
            params,
        });
    }
    //获取自定义打印模板
    getLoadData(params) {
        return Axios.post(Mappings.form.batchLoad, params);
    }
    //获取是否有自定义打印模板
    getConfirmIsPrint(params) {
        return Axios.get(Mappings.application.getBizFormPrint, {
            params,
        });
    }
    /**
     * 导入数据
     * @param params
     */
    selectFormTitle(params) {
        return Axios.get(Mappings.application.selectFormTitle, { params });
    }
    /**
     * 查询列表表单留痕
     * @param params
     */
    getFormMarkingList(params) {
        return Axios.post(Mappings.application.getFormMarkingList, params);
    }
    /**
     * 查询详情页表单留痕
     * @param params
     */
    getFormMarkingDetail(params) {
        return Axios.get(Mappings.application.getFormMarkingDetail, { params });
    }
    /**
     * 获取应用分组列表接口
     * @param {Object} params
     * @returns
     */
    getAppgroupList(params) {
        return Axios.get("/api/app/appgroup/list", { params });
    }
    /**
     * 获取所有分组
     */
    getAllAppGroups(params) {
        return Axios.get("/api/app/apppackage/list_all_group", {
            params,
        });
    }
    /* 获取应用中心首页列表 */
    getAppList() {
        return Axios.get("/api/app/apppackage/list");
    }
    // 二开 开始 
    //撤回流程
    RevokeWorkitem(params) {
        return Axios.get('/api/runtime/workflow/revoke_workitem', { params });
    }
    // 根据id查询refid 下载所有coi附件信息
    GetFormRefId(params) {
        return Axios.post('/api/coi/queryRefIdBySchemaCodeAndObjectId', params);
    }
    // // 下载所有coi附件信息
    // DownloadAllList():Promise<HttpResponse<any>>{
    //   return Axios.get('/api/coi/queryAllRefId');
    // }
    loadlistInfo(params) {
        return Axios.get('/api/runtime/form/load', { params });
    }
    // 发送邮件 e-chop
    hrSendEmailToNew(params) {
        return Axios.get('/api/echop/hrSendEmailToNew', { params });
    }
    //发送邮件 剩下的两个模型
    sendEmailToSap(params) {
        return Axios.get('/api/echop/sendEmailToSap?emailAddress', { params });
    }
    //EChop DD API 获取查看合同链接
    EchopDDViewUrl(params) {
        return Axios.post('/api/newechop/batchViewUrl', qs.stringify(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        });
    }
    //EChop DD API 获取签署合同链接
    EchopDDSignUrl(params) {
        return Axios.post('/api/newechop/batchSignBjbmw', qs.stringify(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        });
    }
    //EChop DD API DELAER RELEASE
    DDDealerRelease(params) {
        return Axios.post('/api/newechop/audit', qs.stringify(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        });
    }
    //EChop DD API 是否允许下载合同
    AllowDownload(params) {
        return Axios.post('/api/newechop/allowReceiverDownload', qs.stringify(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        });
    }
    //EChop DD API Reject 
    UpdateStatus(params) {
        return Axios.post('/api/newechop/updateStatus', qs.stringify(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        });
    }
    //EChop DD API Reject 
    SendSignEmail(params) {
        return Axios.post('/api/newechop/sendSignEmail', qs.stringify(params), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
        });
    }
    echopViewUrl(params) {
        return Axios.post('/api/echop/viewUrl', params);
    }
    //盖章
    GetSealChop(params) {
        return Axios.post('/api/echop/batchSign', params);
    }
    // 设置盖章位置
    SetTheSealPosition(params) {
        return Axios.post('/api/echop/preSignUrl', params);
    }
    //下载
    GetEChopDownload(params) {
        return Axios.post(`/api/echop/download?bizId=${params.bizId}`);
    }
    finishInstance(params) {
        return Axios.get('/api/runtime/workflow/finish_instance', { params });
    }
    // 修改流程状态接口 IT Application
    ModifyProcessStatus(params) {
        return Axios.get('/api/it/updateStatus', { params });
    }
    // 获取用户Dimission数据
    GetEmployeeGroupInfo() {
        return Axios.get('/api/businessCard/employee_group');
    }
    //结束
    // 获取用户Certificate数据quanx
    GetCertificateGroupInfo() {
        return Axios.get('/api/certificate/checkUserRole');
    }
    // 获取用户Certificate数据quanx
    GetAppGroupInfo(url) {
        return Axios.get(url);
    }
    // 批量修改
    batchUpdate(params) {
        return Axios.post(Mappings.application.batchUpdate, params);
    }
    // 获取批量修改记录
    getBatchUpdateLog(params) {
        return Axios.get(Mappings.application.batchUpdateLog, { params });
    }
    //checkingReport Survey No查询条件默认值
    getcheckingReportListOne() {
        return Axios.post('/api/survey/checkingReport/getQueryListOne');
    }
    //checkingReport Survey No查询条件默认值
    getdetailReportListOne() {
        return Axios.post('/api/survey/detailReport/getQueryListOne');
    }
    //summaryReport 查询条件默认值
    getsummaryReportList() {
        return Axios.post('/api/survey/summaryReport/getFirstList');
    }
    //获取用户信息
    getUserInfo(id) {
        return Axios.get(`/api/organization/user/info?id=${id}`);
    }
}
